module.exports = __webpack_public_path__ + "static/media/airspace.1260bcf2.jpeg";